import React from 'react';
import * as R from 'ramda';
// components
import { ActionsElement } from '../../../components/actions-element';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
//////////////////////////////////////////////////

const blueColor = G.getTheme('colors.dark.blue');

const getOptions = ({ entity, isFleetProfile, closeFixedPopup, handleOpenAudit, handleRemoveItem }) => {
  const { guid } = entity;

  let actions = [
    {
      text: G.getWindowLocale('titles:audit', 'Audit'),
      frontIcon: I.renderAuditHistoryIcon(blueColor, 15, 17),
      action: () => {
        closeFixedPopup();
        handleOpenAudit(guid, entity);
      },
    },
  ];

  if (G.getPropFromObject(GC.FIELD_EDITABLE, entity)) {
    actions = R.append(
      {
        frontIcon: I.trash(blueColor),
        permissions: G.ifElse(isFleetProfile, ''),
        text: G.getWindowLocale('actions:delete', 'Delete'),
        action: () => {
          closeFixedPopup();
          handleRemoveItem(guid, entity);
        },
      },
      actions,
    );
  }

  return actions;
};

export const RowActions = (props) => (
  <ActionsElement options={getOptions(props)} />
);
